import React from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';

import { BackIcon } from 'assets/icons';
import ErrorImg from 'assets/images/404.webp';
import { PrimaryBtn } from 'components/UI/Buttons';

const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <Box style={{ width: '100%' }} my={2}>
      <Box
        sx={{
          borderRadius: 4,
          p: 2,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img src={ErrorImg} alt="Error" style={{ width: 'min(600px, 98%)' }} />
        <PrimaryBtn onClick={() => navigate('/clients')} sx={{ mt: 6 }} startIcon={<BackIcon />} variant="contained">
          Volver a clientes
        </PrimaryBtn>
      </Box>
    </Box>
  );
};

export default ErrorPage;
